export default "__VITE_ASSET__CBqGVAqb__"